<template>
  <ContentTemplate title="Azure Boards" icon="integrations/azure.svg" :step="step + '/4'"
                   :containerSizeSmall="true">
    <div class="azure-boards-step">
      <Step1 v-if="step === 1" @continueClick="selectImportOptionsAndContinue($event)"
             @cancelClick="backToIntegrationView()"/>
      <Step2 v-if="step === 2" @continueClick="selectProjectAndContinue($event)"
             @cancelClick="step--"/>
      <Step3 v-if="step === 3" :selectedProjectKey="integrationRequest.projectKey"
             @continueClick="selectIssueTypeAndContinue($event)" @cancelClick="step--"/>
      <Step4 v-if="step === 4" :selectedProjectKey="integrationRequest.projectKey"
             @continueClick="finishIntegration($event)" @cancelClick="step--"/>
    </div>
  </ContentTemplate>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import {IntegrationNs, SettingNs} from '@shared/types'
import Step1 from './step/step-1.vue'
import Step2 from './step/step-2.vue'
import Step3 from './step/step-3.vue'
import Step4 from './step/step-4.vue'
import {ContentTemplate} from "@shared/components"
import {mapStores} from "pinia"
import {useWorkspaceStore} from "@shared/stores/workspace.store"
import {useIntegrationStore} from "@domains/settings/stores/integration.store"
import {useGeneralStore} from "@shared/stores/general.store"
import {toast} from '@shared/ms-components'

export default defineComponent({
  name: 'AzureBoardsView',
  components: {
    ContentTemplate,
    Step1,
    Step2,
    Step3,
    Step4,
  },
  computed: {
    ...mapStores(useWorkspaceStore, useIntegrationStore, useGeneralStore),
  },
  data() {
    return {
      integrationRequest: {} as IntegrationNs.ProjectIntegrationRequest,
      step: 1,
    }
  },
  methods: {
    selectImportOptionsAndContinue(importConfig: any) {
      this.integrationRequest.synchType = importConfig.selectedOption
      this.integrationRequest.importOption = importConfig.extraOption
      this.step++
    },
    selectProjectAndContinue(selectedProject: any) {
      this.integrationRequest.msProjectId = selectedProject.msProjectId
      this.integrationRequest.projectKey = selectedProject.projectKey
      this.step++
    },
    selectIssueTypeAndContinue(issueMatching: any) {
      this.integrationRequest.issueMatching = issueMatching
      this.step++
    },
    finishIntegration(importNow: boolean) {
      this.generalStore.setLoading(true)
      this.integrationRequest.importNow = importNow
      this.integrationRequest.workspaceId = this.workspaceStore.getSelectedWorkspaceId
      this.integrationRequest.integrationType = IntegrationNs.IntegrationTypeEnums.AZURE

      this.integrationStore.completeIntegration(this.integrationRequest)
        .then(() => {
          toast.success('Synchronization with Azure Boards started')
        })
        .catch((error) => {
          let message = 'Synchronization failed. Please try again'
          if (error?.response?.data?.message) {
            message = error.response.data.message
          }
          toast.error(message)
        })

      setTimeout(() => {
        this.generalStore.setLoading(false)
        this.backToIntegrationView()
      }, 3000)
    },
    backToIntegrationView() {
      this.$router.push({
        name: SettingNs.SettingRouteEnums.INTEGRATIONS_DETAIL,
        params: {integration: IntegrationNs.IntegrationTypeEnums.AZURE},
      })
    },
  },
})
</script>

<style lang="scss">
.azure-boards-step {
  footer {
    display: flex;
    justify-content: flex-end;
    margin-top: var(--space-16);
  }

  .project {
    p {
      font-size: var(--fs-14);
      font-weight: normal;
    }

    &-list {
      background-color: var(--card-bg);
      border: 1px solid var(--card-border);
      box-shadow: var(--card-shadow);
      height: 500px;
      list-style-type: none;
      padding: var(--space-8);
      border-radius: $br-sm !important;
      overflow-y: scroll;

      &:hover {
        box-shadow: var(--card-shadow-active);
      }

      .selected {
        background-color: var(--item-blue-bg-hover);
        border: 1px solid var(--item-blue-border-hover);
      }
    }

    &-item {
      background-color: var(--transparent);
      border: 1px solid var(--transparent);
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: var(--fs-14);
      padding: var(--space-8);
      cursor: pointer;
      color: var(--text-dark);
      border-radius: $br-sm;
    }
  }
}
</style>
